import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import {
  SelectControl,
  SelectField,
  SelectLabel,
  SelectOption,
} from 'components/atoms/Select';
import {
  DEFAULT_TERM_LENGTH,
  SELECTABLE_FINANCE_TERMS,
  SELECTABLE_LEASE_TERMS,
} from 'shared/utils/constants';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import { useRecoilValue } from 'recoil';
import { scanModeInputAtom } from 'containers/deal/recoil/atoms';
import { MSAPIScanMode } from 'shared/types/marketScan';
import { labelInputStyles } from '../styles';

export const TermLengthFilter = ({
  setFilterValue,
  disabled = false,
}: {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();

  const scanMode = useRecoilValue(scanModeInputAtom);
  const isLease = scanMode === MSAPIScanMode.Lease;

  const terms = isLease ? SELECTABLE_LEASE_TERMS : SELECTABLE_FINANCE_TERMS;
  return (
    <SelectControl fullWidth>
      <SelectLabel sx={labelInputStyles}>
        <FieldLabelIconMui5 icon={faCalendarAlt} color='primary' />
        Term Length
      </SelectLabel>
      <SelectField
        variant='outlined'
        displayEmpty
        onChange={(e) => {
          if (disabled) {
            return;
          }
          setFilterValue('term', String(e.target.value));
        }}
        value={filters.term || DEFAULT_TERM_LENGTH}
        label='Term'
      >
        {terms.map((term) => {
          return (
            <SelectOption key={term} value={term}>
              {`${term} ${isFinite(Number(term)) ? 'months' : ''}`}
            </SelectOption>
          );
        })}
      </SelectField>
    </SelectControl>
  );
};
